import React from 'react';
interface CheckboxOption {
  value: string;
  label: string;
}
interface CheckboxGroupProps {
  name: string;
  label: string;
  options: CheckboxOption[];
  values: string[];
  onChange: (values: string[]) => void;
  tooltip?: React.ReactNode;
}
export function CheckboxGroup({
  name,
  label,
  options,
  values,
  onChange,
  tooltip
}: CheckboxGroupProps) {
  const handleChange = (optionValue: string, checked: boolean) => {
    if (checked) {
      onChange([...values, optionValue]);
    } else {
      onChange(values.filter(v => v !== optionValue));
    }
  };
  return <div className="space-y-4" data-id="element-19">
      <label className="flex items-center text-base font-medium text-gray-900" data-id="element-20">
        {label}
        {tooltip}
      </label>
      <div className="space-y-3" data-id="element-21">
        {options.map(option => <label key={option.value} className="flex items-center p-4 border border-gray-300 cursor-pointer hover:border-yellow-500 hover:shadow-[0_0_8px_rgba(234,179,8,0.4)] transition-all duration-300" data-id="element-22">
            <input type="checkbox" name={name} value={option.value} checked={values.includes(option.value)} onChange={e => handleChange(option.value, e.target.checked)} className="w-4 h-4 text-yellow-500 border-gray-300 focus:ring-yellow-500" data-id="element-23" />
            <span className="ml-3 text-base text-gray-900" data-id="element-24">{option.label}</span>
          </label>)}
      </div>
    </div>;
}